import React, { useContext } from "react";
import { Link,Outlet } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTachometerAlt,faSignOut, faUser} from '@fortawesome/free-solid-svg-icons';
import { FarmerContext } from "./FarmerContext";
export default function FarmerAccount(){
    const {farmersData}=useContext(FarmerContext)
    return (
        <div>
           <div className=" flex flex-row max-w-full min-w-fit gap-x-4 mb-4">
            <Link to="change" className=" flex flec-col hover:text-blue-500">
              <FontAwesomeIcon icon={faTachometerAlt} className=" w-12 h-12 hover:text-blue-500"/>account
             </Link>
             <Link to="logout">
               <FontAwesomeIcon icon={faSignOut} className=" w-12 h-12 hover:text-blue-500"/>Logout
             </Link>            
            </div>
            <div className=" flex flex-col ">
              {farmersData?.profile?<img src={farmersData?.profile} className=" w-12 h-12 rounded-full"/>:<FontAwesomeIcon icon={faUser} className=" w-12 h-12 rounded-full"/>}
               <p>Username :{farmersData?.username}</p>
               <p>Useremail :{farmersData?.email}</p>
               <p>name :{farmersData?.name}</p>
              </div>
              
             <Outlet/>
                
        </div>
    )
}